"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noop = void 0;
function noop() {}
exports.noop = noop;
